// Utility function to determine whether a given URL belongs to the current domain (local) or is external

export function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}

// ****************************************************************************************************************************************************
// Utility function to add target attribute to external links

export function getLinkTargetAttr(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

// ****************************************************************************************************************************************************
// Utility to adjust lineup button layout based on container width
export function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const lineup = $(element);
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    if (icons.width() + buttons.width() > containerSize - 20) {
      buttonContainer.addClass('column');
    }

    if (!icons.children().length) {
      icons.remove();
    }
  });
}

// ****************************************************************************************************************************************************
// Utility function to create custom burger toggle button

export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  updateToggle();
  openMenuKeyboard();

  function updateToggle() {
    currentToggle.attr('tabindex', '0');
    for (let i = 0; i < 3; i++) {
      currentToggle.append("<span class='toggle-line'></span>");
    }
  }

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

// ****************************************************************************************************************************************************
// Function to customize search button

export function customizeSearch() {
  $('.header .searchSubmitButton').attr('tabindex', '-1');

  const input = $('.header .inputFieldTextbox');
  const defaultText = 'Search Website';

  input.on('focus', function () {
    if ($(this).val() === defaultText) {
      $(this).val('');
    }
  });

  input.on('blur', function () {
    if ($(this).val().trim() === '') {
      $(this).val(defaultText);
    }
  });
}

// ****************************************************************************************************************************************************
// Utility function to customize sign up widget

export function modifySignup() {
  const signupWidget = $('.signup-section .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    let paragraphText =
      'Get all the latest Douglas County Fairgrounds Complex updates as they happen!';
    if ($('body').hasClass('douglas-county-fair')) {
      paragraphText = 'Get all the latest Douglas County Fair updates as they happen!';
    }

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h2>Email Signup</h2>
        <p>${paragraphText}</p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Email Address')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('SIGN UP');
  });
}

// ****************************************************************************************************************************************************
// Utility function to clean main content

export function cleanContent() {
  $('body .content').empty();
}

// ****************************************************************************************************************************************************
//  Checks if the body has a specific class name

export const isPage = (className) => $('body').hasClass(className);

// ****************************************************************************************************************************************************
// Utility to move theme widgets before the main content

export function moveWidgetsToMainContent(themeData) {
  const currentTheme = themeData.find((theme) => isPage(theme.classLanding));

  const subthemeWidgetsContainer = $(`#${currentTheme.widgetContainer}`);
  const subthemeWidgets = subthemeWidgetsContainer.children();
  const content = $('.content');
  content.append(subthemeWidgets);
  $(`#${currentTheme.widgetContainer}`).empty();
}

// ****************************************************************************************************************************************************
// Function to set the header logo link URL

export function logosURL() {
  const activeSubtheme = (themeData || []).find((theme) => $('body').hasClass(theme.classBody));
  $('.header-logo').attr('href', activeSubtheme ? activeSubtheme.link : '/');
}

// ****************************************************************************************************************************************************
// Updates the favicon to the Fair theme icon.

export function applyFairThemeFavicon() {
  $('link[href*="favicon"]').each(function () {
    $(this).attr('href', `${CLIENTRESOURCEPATH}dist/images/fair/favicon.ico?sv=${SITEVERSION}`);
  });
}
